import React from "react";

const LedgerBanners = () => {
  return (
    <>
      {/* באנר ראשון */}
      <div className="ledger-banner-right">
        <a
          href="https://shop.ledger.com/pages/ledger-nano-s-plus/?r=d75e06f3b125"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/img/ledger.png"
            alt="Ledger Nano S Plus"
          />
        </a>
      </div>

      {/* באנר שני - אותו עיצוב בדיוק, רק מתחת לראשון */}
      <div className="ledger-banner-right second-banner">
        <a
          href="https://shop.ledger.com/pages/referral-program?referral_code=1K5NYH4PMN84Y"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/img/ledgerLogo.png"
            alt="Ledger Referral Program"
          />
        </a>
      </div>

      {/* באנר שני - אותו עיצוב בדיוק, רק מתחת לראשון */}
      <div className="ledger-banner-right third-banner">
        <a
          href="https://cryptocom.sjv.io/LKvKkV"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/img/cryptoComLogo.png"
            alt="Crypto.com"
          />
        </a>
      </div>

      <style>
        {`
          .ledger-banner-right {
            position: fixed;
            top: 80px;
            right: 10px;
            z-index: 10000;
            display: flex;
            justify-content: center;
            opacity: 0.85;
            transition: transform 1s ease, opacity 0.3s ease;
            transform: translateX(200px);
            animation: slideInRight 1s forwards;
          }

          /* הבאנר השני מתחת לראשון */
          .ledger-banner-right.second-banner {
            top: 260px;
          }
          .ledger-banner-right.third-banner {
            top: 325px;
          }

          .ledger-banner-right:hover {
            opacity: 1;
          }

          .ledger-banner-right img {
            border-radius: 10px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
            width: 100%;
            max-width: 160px;
            max-height: 150px;
            animation: pulse 2s infinite;
          }

          @keyframes slideInRight {
            to {
              transform: translateX(0);
              opacity: 0.9;
            }
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.03); }
            100% { transform: scale(1); }
          }

          @media (max-width: 1280px) {
            .ledger-banner-right img { max-width: 120px; max-height: 120px; }
            .ledger-banner-right.second-banner { top: 230px; }
            .ledger-banner-right.third-banner {
            top: 250px;
             max-height: 60px;
            
          }

          @media (max-width: 768px) {
            .ledger-banner-right img { max-width: 90px; max-height: 90px; }
            .ledger-banner-right { top: 80px; }
            .ledger-banner-right.second-banner { top: 200px; }
            .ledger-banner-right.third-banner {
            top: 220px;
            max-height: 45px;
          }

          @media (max-width: 480px) {
            .ledger-banner-right img { max-width: 60px; max-height: 60px; }
            .ledger-banner-right { top: 60px; }
            .ledger-banner-right.second-banner { top: 140px; }
            .ledger-banner-right.third-banner {
            top: 160px;
             max-height: 30px;
          }
          }
        `}
      </style>
    </>
  );
};

export default LedgerBanners;
